import { useHomesStore } from '~/store';
import { CurationsTabContent } from './components/Curations';
import { SearchProfilesTabContent } from './components/SearchProfiles';
import { FeaturesTabContent } from './components/Features';
import { SpeculatorCurations } from './components/SpeculatorCurations';
import { CategoriesTabContent } from './components/Categories';
import { PriceRangeTabContent } from './components/PriceRange';
import { LivingSpaceRangeTabContent } from './components/LivingSpaceRange';
import { RoomsRangeTabContent } from './components/RoomsRange';
import { FEATURES, ROUTES } from '@habity/constants';
import { usePathname } from 'next/navigation';
import { usePathUtils } from '~/hooks/usePathUtils';
import { useAgency } from '~/hooks/useAgency';

export const SuggestionTabs = () => {
  const pathname = usePathname();
  const { isPath } = usePathUtils();
  const { getProjectCuratedButtons } = useAgency();
  const locations = useHomesStore((state) => state.locations);
  const filters = useHomesStore((state) => state.filters);

  const isHomesSearch = isPath(ROUTES.SEARCH.HOMES);
  const isProjectsSearch = isPath(ROUTES.SEARCH.PROJECTS);
  const isSpeculatorsSearch = isPath(ROUTES.SEARCH.SPECULATORS);

  // Check filter states for progressive flow
  const hasLocation = locations && locations.length > 0;
  const hasCategory = filters?.categories && filters.categories.length > 0;
  const hasPriceRange =
    filters?.price_min !== undefined || filters?.price_max !== undefined;
  const hasLivingSpaceRange =
    filters?.living_space_min !== undefined ||
    filters?.living_space_max !== undefined;
  const hasRoomsRange =
    filters?.rooms_min !== undefined || filters?.rooms_max !== undefined;

  if (isSpeculatorsSearch) {
    return <SpeculatorCurations />;
  }

  if (isProjectsSearch) {
    return (
      <CurationsTabContent
        buttons={getProjectCuratedButtons()}
        tab="projects"
      />
    );
  }

  if (isHomesSearch) {
    if (pathname?.includes('search')) {
      return <SearchProfilesTabContent />;
    }

    // Progressive filter flow:
    // 1. No location -> Show default curations
    // 2. Location selected, no category -> Show categories
    // 3. Location + category, no rooms -> Show rooms ranges
    // 4. Location + category + rooms, no living space -> Show living space ranges
    // 5. Location + category + rooms + living space, no price -> Show price ranges
    // 6. All selected -> Show features (and keep showing)
    if (!hasLocation) {
      return <CurationsTabContent />;
    }

    if (!hasCategory) {
      return <CategoriesTabContent />;
    }

    if (!hasRoomsRange) {
      return <RoomsRangeTabContent />;
    }

    if (!hasLivingSpaceRange) {
      return <LivingSpaceRangeTabContent />;
    }

    if (!hasPriceRange) {
      return <PriceRangeTabContent />;
    }

    // Has all filters -> show features
    return <FeaturesTabContent featuresFilters={FEATURES} />;
  }

  return null;
};
